import React from 'react';
import ShrimpLottie from '../shared/ShrimpLottie';
import { MyRipples } from '../../helpers/rippleAnimation.js';

class SubmitWithLoader extends React.Component {
  render() {
    const {
      className = '',
      disabled,
      isUpdating,
      onClick,
      formId,
      updatingText,
    } = this.props;

    let inputClasses = 'new-btn new-btn--full-mobile new-btn--solid-green ';
    inputClasses += className;

    let animationClasses = 'submit-button-loader__animation-wrap';
    animationClasses += isUpdating
      ? ' submit-button-loader__animation-wrap--show'
      : '';

    const inputProps = {
      className: inputClasses,
      disabled,
      value: this.getButtonText(),
      onClick,
      form: formId,
    };
    return !disabled ? (
      <div className="submit-button-loader__wrap">
        <MyRipples>
          <input type="submit" {...inputProps}></input>
        </MyRipples>
        <div className={animationClasses}>
          <ShrimpLottie height={40} width={40} />
          {updatingText && (
            <span className="submit-button-loader-text">{updatingText}</span>
          )}
          {updatingText && <ShrimpLottie height={40} width={40} />}
        </div>
      </div>
    ) : (
      <input type="submit" {...inputProps} />
    );
  }

  getButtonText = () => {
    const { isUpdating, hasUpdated, value } = this.props;
    // button text disappears when sending
    let buttonText = !isUpdating ? value : '';

    // button text becomes 'Saved' when finished saving
    buttonText = hasUpdated ? 'Saved' : buttonText;

    return buttonText;
  };
}

export default SubmitWithLoader;



// WEBPACK FOOTER //
// ./src/components/new/SubmitWithLoader.js